import {useEffect,useState} from 'preact/hooks';
import {Button} from '@/ui/components';
import {UI_PANEL_BORDER} from '@/ui/consts';
import {useClient} from '@/ui/context';
import {useWindowManager} from '@/ui/in-game';
import {clearWorldTicket,getWorldTicket,sendWorldTicket,subscribeWorldTicket,type TravelChoice} from '@/world-tickets';
import {DialogBase} from './dialog-base';

export function WorldTicketDialog(){
 const client=useClient(),windows=useWindowManager();const[,refresh]=useState(0),[search,setSearch]=useState(''),[selected,setSelected]=useState<TravelChoice>();
 const close=()=>{sendWorldTicket(client,'world_ticket_cancel');windows.closeDialog('worldTicket')};
 useEffect(()=>{
  const off=subscribeWorldTicket(client,()=>refresh(n=>n+1));const map=client.mapId;
  const timer=window.setInterval(()=>{if(client.worldLoading||client.mapId!==map||getWorldTicket(client).complete)windows.closeDialog('worldTicket')},200);
  return()=>{off();clearInterval(timer);clearWorldTicket(client)};
 },[client]);
 const {snapshot,pending,error}=getWorldTicket(client);
 const choices=snapshot?.destinations.filter(d=>d.name.toLowerCase().includes(search.toLowerCase()))??[];
 return <DialogBase id='worldTicket' title='World Ticket' size='md' touchScroll onClose={close}>
  <div class='flex flex-col gap-3 p-3 text-sm'>
   <p>Where would you like to go? Travelling uses one World Ticket.</p>
   <input class={`input input-bordered border ${UI_PANEL_BORDER} w-full`} aria-label='Search destinations' placeholder='Find a destination…' value={search} onInput={e=>setSearch(e.currentTarget.value)}/>
   <div class='flex flex-col gap-2 max-h-64 overflow-y-auto' role='listbox' aria-label='Destinations'>
    {choices.map(d=><button key={d.id} type='button' role='option' aria-selected={selected?.id===d.id} class={`btn min-h-11 w-full justify-start ${selected?.id===d.id?'btn-primary':'btn-ghost'} border ${UI_PANEL_BORDER}`} disabled={pending} onClick={()=>setSelected(d)}>{d.name}</button>)}
    {!choices.length&&<p>{error||'No matching destinations.'}</p>}
   </div>
   {error&&<p role='alert'>{error}</p>}
   <div class='flex gap-2'><Button variant={['primary']} disabled={pending||!selected||!snapshot?.destinations.some(d=>d.id===selected.id)} onClick={()=>{if(selected)sendWorldTicket(client,'world_ticket_travel',selected)}}>{pending?'Travelling…':selected?`Travel to ${selected.name}`:'Choose a destination'}</Button><Button disabled={pending} onClick={close}>Cancel</Button></div>
   <p class='text-xs opacity-70'>Canceling keeps your ticket.</p>
  </div>
 </DialogBase>;
}
